<template>
  <div>
      <div class="top-message">
        <van-image width="150" :src="require('../../assets/error.svg')"/>
        <div>非公司员工禁止进入平台</div>
      </div>
      <van-image :src="require('../../assets/jpg_empty.png')"/>
  </div>
</template>

<script>
export default {
  props: {
    msg: String
  }
}
</script>

<style>
#app {
  height: auto;
  background: #FFFFFF;
}
.top-message{
  text-align: center;
  margin-top: 5%;
}
</style>
